<template>
  <div id="show-root-toutiao">
    <router-view></router-view>
    <footer-nav></footer-nav>
  </div>
</template>

<script>
import footerNav from '../../components/toutiao/footerNav'

export default {
  name: "index",
  components: {
    footerNav,
  },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/toutiaoApp/index.vue